import { useCallback, useEffect, useState } from "react";
import { PaymentMethodE } from "../../../../Api/dto/Competition_POST_PUT";
import {
  VStack,
  Text,
  Box,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  Textarea,
  Button,
  Spinner,
} from "@chakra-ui/react";
import { SignupClient } from "../../../../Api/client/CompetitionClient";
import {
  DisciplineSignupDto_POST_PUT,
  InvoiceContactInfo,
  SignupRequest,
} from "../../../../Api/dto/SignupRequest_POST";
import { PaymentMethodSubstepState } from "./Step5Substep1PaymentMethod";
import { SignupResponseDto } from "../../../../Api/dto/SignupResponseDtos";
import { useSessionState } from "../../../../Session/SessionService";
import { SignupUnit } from "../SignupFlow";

const INITIAL_STATE: PaymentSubstepState = {
  emailVerificationInitiated: false,
  signupRequestSent: false,
  tpcResponse: undefined,
  signupResponse: undefined,
  signupResponseCode: undefined,
};

export interface PaymentSubstepState {
  emailVerificationInitiated: boolean;
  signupRequestSent: boolean;
  tpcResponse: { c2: string; timestamp: number } | undefined | null;
  signupResponse: SignupResponseDto | undefined | null;
  signupResponseCode: number | undefined;
}

interface StateAndModifiers {
  state: PaymentSubstepState;
  modifiers: {
    reset: () => void;
    initiateEmailVerification: () => Promise<{
      status: number;
      body?:
        | {
            c2: string;
            timestamp: number;
          }
        | undefined;
    }>;
    sendSignupRequest: (
      competitionTag: string,
      signupDto: DisciplineSignupDto_POST_PUT,
      requestedPrice?: number
    ) => Promise<{
      status: number;
      body?: SignupResponseDto | undefined;
    }>;
    sendSignupRequestWithVerificationCode: (
      competitionTag: string,
      signupDto: DisciplineSignupDto_POST_PUT,
      c1: string
    ) => Promise<{
      status: number;
      body?: SignupResponseDto | undefined;
    }>;
  };
}

//
export function useInitiateSignup(email: string) {
  const [state, setState] = useState<PaymentSubstepState>({
    ...INITIAL_STATE,
  });

  const reset = useCallback(() => setState(INITIAL_STATE), [setState]);

  const initiateEmailVerification = useCallback(async () => {
    setState((old) => ({ ...old, emailVerificationInitiated: true }));

    return SignupClient.initiateEmailVerification(email).then((response) => {
      if (response.body) {
        setState((old) => ({
          ...old,
          tpcResponse: response.body!,
        }));
      }
      return response;
    });
  }, [email]);

  const sendSignupRequest = useCallback(
    async (
      competitionTag: string,
      signupDto: DisciplineSignupDto_POST_PUT,
      requestedPrice?: number
    ) => {
      setState((old) => ({
        ...old,
        signupRequestSent: true,
        emailVerificationInitiated: false, ////// TODO   CHECK if this is OK. Test changing from one to theother...
      }));
      return SignupClient.pushSignupRequest(
        competitionTag,
        signupDto,
        email || "",
        requestedPrice
      ).then((response) => {
        setState((old) => ({
          ...old,
          signupResponse: response.body,
          signupResponseCode: response.status,
        }));
        return response;
      });
    },
    [email]
  );

  const sendSignupRequestWithVerificationCode = useCallback(
    async (
      competitionTag: string,
      signupDto: DisciplineSignupDto_POST_PUT,
      c1: string,
      correctedPrice?: number
    ) => {
      setState((old) => ({ ...old, signupRequestSent: true }));
      const c2 = state.tpcResponse?.c2 ?? undefined;
      const timestamp = state.tpcResponse?.timestamp ?? undefined;
      console.log("SEND ", c1, c2, timestamp);
      return SignupClient.pushSignupRequest(
        competitionTag,
        signupDto,
        email,
        undefined,
        c1,
        c2,
        timestamp
      ).then((response) => {
        setState((old) => ({
          ...old,
          signupResponse: response.body,
          signupResponseCode: response.status,
        }));
        return response;
      });
    },
    [email, state.tpcResponse?.c2, state.tpcResponse?.timestamp]
  );

  return {
    state,
    modifiers: {
      initiateEmailVerification,
      sendSignupRequest,
      sendSignupRequestWithVerificationCode,
      reset,
    },
  } as StateAndModifiers;
}

//isDisabled={!paymentFinalizedDetailsState.state.valid}
//if (emailSelectionState.state.emailVerificationNeeded) {

export function ButtonInitiatingPaymentOfEmailVerification(props: {
  paymentMethod: PaymentMethodE;
  isDisabled: boolean;
  isLoading: boolean;
  emailVerificationRequired: boolean;
  cost?: number;
  initiateEmailVerification: () => void;
  sendSingupRequestWithoutEmailVerification: () => void;
}) {
  const isInvoice = props.paymentMethod == PaymentMethodE.INVOICE_MAN;

  useEffect(() => {
    console.log("Step 4 input state: ", props);
  }, [
    props.cost,
    props.emailVerificationRequired,
    props.isDisabled,
    props.paymentMethod,
  ]);

  return (
    <Button
      borderRadius={isInvoice ? "0px" : "5px"}
      marginBottom={"30px"}
      marginTop={"20px"}
      width={isInvoice ? "full" : undefined}
      fontSize={isInvoice ? "xl" : undefined}
      isDisabled={props.isDisabled}
      colorScheme={"green"}
      onClick={() => {
        if (props.emailVerificationRequired) {
          props.initiateEmailVerification();
        } else {
          props.sendSingupRequestWithoutEmailVerification();
        }
      }}
    >
      {props.isLoading ? <Spinner /> : "Slutför anmälan"}
      {/*props.cost < 5
        ? "Slutför anmälan" // No need to verify email, just send it as "swish payment" and it will not charge
        : isSwishAuto // No need to verify email
        ? "Starta Swish betalning"
        : "Nästa"*/}
    </Button>
  );
}

export function createSignupRequest(
  signupUnits: SignupUnit[],
  paymentMethod: PaymentMethodE,
  discount: string | null,
  invoiceData?: InvoiceContactInfo
): DisciplineSignupDto_POST_PUT {
  return {
    signups: signupUnits.flatMap((su) => su),
    invoice: invoiceData,
    paymentMethod: paymentMethod!,
    discountKey: discount ?? undefined,
    swishNumber: "",
  };
}
